import { render, staticRenderFns } from "./ProductBrowserWrapper.vue?vue&type=template&id=8bcbb13c&scoped=true&"
import script from "./ProductBrowserWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductBrowserWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductBrowserWrapper.vue?vue&type=style&index=0&id=8bcbb13c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcbb13c",
  null
  
)

export default component.exports